import { query, request } from '@/utils/request';
import { stringify } from 'qs';

const prefix = '';

/**
 * 分页获取机构或者部门下操作人员列表
 *
 * @param institutionId
 * @param departmentId
 * @param pageSize
 * @param pageNo
 * @return
 */
export async function getInstitutionMember(params) {
  return request(`${prefix}/api/user/organization/list?${stringify(params)}`);
}

/**
 * 20203-06-29 版本修改 人员管理越权接口替换
 */
export async function getOrganizationOperators(params) {
  return request(`${prefix}/api/zlbuser/organization/operators?${stringify(params)}`);
}

// 人员列表（脱敏）
export async function getOrganizationOperatorsDesensitization(params) {
  return request(
    `${prefix}/api/zlbuser/organization/operators/desensitization?${stringify(params)}`,
  );
}

export async function getInstitutionTree(params) {
  return request(`${prefix}/api/user/institution/department/tree?${stringify(params)}`);
}

// 获取职级枚举集合
export async function getOperatorRank() {
  return request(`${prefix}/api/user/dictionary/operator/rank`);
}
// 获取政治面貌枚举集合
export async function getPoliticsstatus() {
  return request(`${prefix}/api/user/dictionary/politicsstatus`);
}
// 获取人员任职枚举集合
export async function getPersonnelOffice() {
  return request(`${prefix}/api/user/dictionary/personnel/office`);
}
// 获取人员编制集合
export async function getPersonnelForce() {
  return request(`${prefix}/api/user/dictionary/personnel/force`);
}

/**
 * 查询操作人更多信息
 *
 * @param departmentId 操作人部门id
 * @param operatorId   操作人id
 * @return
 */
export async function getUserDetail(params) {
  return request(`${prefix}/api/user/operator/info?${stringify(params)}`);
}

export async function updateUser(data) {
  return request(`${prefix}/api/user/update/user`, {
    method: 'post',
    data,
  });
}
export async function addUser(data) {
  return request(`${prefix}/api/user/add/user`, {
    method: 'post',
    data,
  });
}

/**
 * @param institutionId
 *  {
 *    departmentId
 *    operatorId
 *  }
 *
 */
export async function deleteUser(data) {
  return request(`${prefix}/api/zlbuser/batch/del/operator`, {
    method: 'post',
    data,
  });
}

/**
 * 批量调整部门
 */
export async function adjustUserDepartment(data) {
  return request(`${prefix}/api/user/change/operator/dept`, {
    method: 'post',
    data,
  });
}

/**
 * 批量获取机构或者部门下操作人员列表
 */
export async function getBatchMember(params) {
  return request(`${prefix}/api/user/organizations/operators?${stringify(params)}`);
}

/**
 * 获取人员列表模版链接
 */
export async function getImportManagerTemplate(params) {
  return request(`${prefix}/api/user/import/template?${stringify(params)}`);
}

/**
 * 上传人员列表Excel
 */
export async function importUpload(data) {
  return request(`${prefix}/api/user/import/upload`, {
    method: 'post',
    data,
  });
}

/**
 * 下载失败文件
 */
export async function importManagerRecord(params) {
  return request(`${prefix}/api/user/import/user/record`, {
    responseType: 'blob',
    params,
  });
}

/**
 * 分页获取机构或者部门下已删除操作人员列表
 * @param params
 * @returns
 */
export async function fetchDeleteEmployeeList(params) {
  return query('/api/zlbuser/organization/delete/list', {
    params,
  });
}

/**
 * 设置身份是否可切换
 */
export async function setCanSwitch(params) {
  return query('/api/zlbuser/setCanSwitch', {
    params,
  });
}

/**
 * 已删除人员详情
 */
export async function getDeleteDetail(params) {
  return request('/api/zlbuser/operator/delete/info', {
    params,
  });
}

// 获取人员详情--不脱敏
export async function getPersonDetail(params) {
  return request('/api/zlbuser/operator/detail', {
    method: 'get',
    params,
  });
}
// 获取人员详情--脱敏
export async function getPersonDetailDesensitization(params) {
  return request('/api/zlbuser/operator/detail/desensitization', {
    method: 'get',
    params,
  });
}
// 操作员信息修改
export async function modifyInfo(data) {
  return request('/api/zlbuser/operator/modify', {
    method: 'post',
    data,
  });
}

// 修改用户的启停状态
export async function switchStatus(data) {
  return request('/api/zlbuser/operator/status/switch', {
    method: 'POST',
    data,
  });
}
// 获取成员的任职信息列表
export async function getDepartmentList(params) {
  return request('/api/zlbuser/operator/department/list', {
    method: 'get',
    params,
  });
}
// 修改人员的部门任职信息
export async function modifyPositionInfo(data) {
  return request('/api/zlbuser/operator/department/modify', {
    method: 'POST',
    data,
  });
}

// 删除人员的部门任职信息
export async function deletePositionInfo(data) {
  return request('/api/zlbuser/operator/department/del', {
    method: 'POST',
    data,
  });
}
// 创建新任职信息（添加到新部门
export async function addDepPosition(data) {
  return request('/zlb/zlbuser/operator/department/add', {
    method: 'POST',
    data,
  });
}

// 批量修改操作人状态
export async function batchSwitchStatus(data) {
  return request('/api/zlbuser/operator/batch/status/switch', {
    method: 'POST',
    data,
  });
}

// 更新操作人在部门或者机构下的排序权重值
export async function operatorOrder(data) {
  return request('/zlb/operation/operator/order', {
    method: 'POST',
    data,
  });
}
